export default __webpack_public_path__ + "static/media/red.05d9ebf3.png";